import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GrassIcon(props: IconProps) {
    return <Icon {...props} iconKey={"grass"}/>
}
